// MUST be the first import — disables Zod 4.x JIT before any
// schema-using module is imported and constructs its validators.
// See zod-config.ts for the why.
import './zod-config'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './design/tokens.css'
import './index.css'
import './i18n'
import { runStorageMigrations } from './lib/storage-migration'
import { initVersionCheck } from './lib/version-check'
import { installGlobalErrorReporting } from './lib/error-reporter'

// Run storage migrations before rendering the app
runStorageMigrations()

// Reload a stale long-lived tab / installed PWA onto the current build when the
// user resumes it after a deploy (closes the iOS-Safari-PWA stale-bundle gap
// that made earlier fixes invisible). No-op on the dev server.
initVersionCheck()

// A promise rejection nobody awaited, or an error outside React's render, is
// reported like an ErrorBoundary crash instead of dying in the console.
installGlobalErrorReporting()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
